import { Gauge } from '@/components/Gauge'
import { DASH, fraction, size, sizeFraction } from '@/ui/format'

// 목록의 자원 칸 하나 — 고리 아래에 `사용량/총량 단위`(`0.6/2 코어`·`2.0/4 GB`). 고리는 총량 대비 비율이다.
// 크기(`size`, 값은 GiB)는 단위를 받지 않는다 — 총량이 GB·TB 를 정한다(`ui/format.ts`).
// 색은 차트 토큰이고 임계값으로 바꾸지 않는다: 얼마나 쓰는지는 사실이지 판정이 아니다. 값이 없으면 빈 고리와 `—`.

export function UsageCell({
  label,
  used,
  total,
  unit,
  color,
}: {
  label: string
  used: number | null | undefined
  total: number | null | undefined
  unit: '코어' | 'size'
  color: string
}) {
  const text = unit === 'size' ? sizeFraction(used, total) : fraction(used, total, unit)
  const ratio = text === DASH || used === null || used === undefined || !total ? null : used / total
  return (
    <div className="flex flex-col items-center gap-1">
      <Gauge compact label={label} fraction={ratio} text={text} color={color} />
      <span className="text-[11px] tabular-nums text-muted-foreground">{text}</span>
    </div>
  )
}

/**
 * 목록의 디스크 칸 — 할당 하나를 글자로(`164GB`). 게스트가 쓴 양은 재지 않으므로 고리가 없다(GPU 칸과 같다).
 * 값은 GiB 이고 단위는 그 값이 정한다(`ui/format.ts` 의 `size`).
 */
export function AllocationCell({ gb }: { gb: number | null | undefined }) {
  return <div className="text-center text-[11px] tabular-nums text-muted-foreground">{size(gb)}</div>
}
